import {Pipe, PipeTransform} from '@angular/core';
import {Pick} from '../core/pick';

@Pipe({name: 'qualifyingDeaths'})
export class QualifiedDeathPipe implements PipeTransform{

    transform(picks: Pick[]) {
        return picks
          .filter(pick => pick.qualifiedDeath)
          .sort(function(p1, p2) {
            if(p2.celebrity.deathDate < p1.celebrity.deathDate) {
              return -1;
            }

            return 1;
          });
    }
}



// WEBPACK FOOTER //
// /Users/william/Documents/gitlab/stovokor/src/app/pipe/qualified-death.pipe.ts